import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {StateLabel} from '../../../common/services/workflow/states-labels.interface';
import {MatSelectChange} from '@angular/material/select';
import {StateEnum} from '../../../common/services';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {DarDossiersService} from '../../../common/services/dossiers/dossiers.service';
import {SubSink} from '@Common/core/utils/subsink';

@Component({
  selector: 'app-filter-list-dar',
  templateUrl: './filter-list-dar.component.html',
  styleUrls: ['./filter-list-dar.component.scss']
})
export class FilterListDarComponent implements OnInit, OnDestroy {
  @Output() allStatusChange = new EventEmitter<boolean>();
  @Output() onStatusChange = new EventEmitter<StateEnum>();
  statusLabels: StateLabel[] = [];
  statusLabelSelected: StateLabel = null;
  allDemandsAndFilter = false;
  subSink = new SubSink();
  constructor(private dossiersSvc: DarDossiersService) { }

  ngOnInit(): void {

  }
  /**
   * Filtrage sur un statut particulier
   * utilisable uniquement lorsque "Tous les dossiers" sont activés
   * @param {MatSelectChange} event
   */
  onStateFiltered(event: MatSelectChange) {
    this._stateFilteredToggle(event.value, event.value ? event.value.id : StateEnum.none);
  }
  /**
   * Affichage de tous les dossier et filtre statut
   * @param {MatCheckboxChange} $event
   */
  onChangedAllCases($event: MatCheckboxChange) {
    this.fetchStatesDemandsOwner();
    this.allDemandsAndFilter = $event.checked;
    this._stateFilteredToggle(false);
    this.allStatusChange.emit($event.checked);
  }
  getClassFromType(state: StateEnum) {
    return `dar-${state}`;
  }
  fetchStatesDemandsOwner() {
    this.subSink.sink = this.dossiersSvc
      .statesMesDemandes()
      .subscribe(_states => this.statusLabels = this.dossiersSvc.getStateTitles(true, _states));
  }
  private _stateFilteredToggle(toggle: boolean, state: StateEnum = StateEnum.none) {
    if (toggle && state !== StateEnum.none) {
      this.onStatusChange.emit(state);
    } else {
      this.allStatusChange.emit(this.allDemandsAndFilter);
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
